import { COURSE_STRUCTURES } from 'constants/common';

type CourseLikeState = {
  structure?: string;
  modules?: { lessons: { status?: string }[] }[];
  lessons?: { status?: string }[];
};

export function applyBulkLessonStatusToCourseLikeState(
  state: CourseLikeState,
  coursePatch: Record<string, unknown>,
  status: string | undefined,
): CourseLikeState {
  if (status === undefined) {
    return { ...state, ...coursePatch };
  }

  if (state.structure === COURSE_STRUCTURES.MODULES) {
    return {
      ...state,
      ...coursePatch,
      modules: (state.modules || []).map((module) => ({
        ...module,
        lessons: module.lessons.map((lesson) => ({
          ...lesson,
          status,
        })),
      })),
    };
  }

  if (state.structure === COURSE_STRUCTURES.LESSONS) {
    return {
      ...state,
      ...coursePatch,
      lessons: (state.lessons || []).map((lesson) => ({
        ...lesson,
        status,
      })),
    };
  }

  return { ...state, ...coursePatch };
}
